// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { loginReducer } from "./user/reducer";
import stockRequestReducer from "./reducers/stockRequestReducer";

console.log("Redux Store Created");

export const store = configureStore({
  reducer: {
    login: loginReducer,
    stockRequests: stockRequestReducer, // Add this
  },
});
